import React, {Component} from 'react';
import {translate} from 'react-i18next';
import config from '../../config/config.js';
import axios from 'axios';
import fileDownload from 'js-file-download';
import PageHeader from '../elements/PageHeader';
import EditLocationGroup from '../elements/locationGroups/EditLocationGroup';
import EditLocation from '../elements/locationGroups/EditLocation';

class LocationGroupsScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            locationGroups: [],
            loading: true,
            filterName: '',
            filterOnlyWithShifts: true,
            locationPrinting: null
        };

        this.loadLocationGroups = this.loadLocationGroups.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleEditLocationGroup = this.handleEditLocationGroup.bind(this);
        this.handlePrintLocationSheet = this.handlePrintLocationSheet.bind(this);
    }

    componentDidMount() {
        this.loadLocationGroups();
    }

    loadLocationGroups() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/location/groups', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false,
                    locationGroups: response.data
                });
            }
        });
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleCheckboxChange(e) {
        this.setState({
            [e.target.name]: !this.state[e.target.name]
        });
    }

    handleEditLocationGroup(locationGroupId) {
        alert(locationGroupId);
    }

    handlePrintLocationSheet(locationId, locationName) {
        this.setState({locationPrinting: locationId});
        axios(config.server.endpoint + 'backend/location/print/' + locationId, {
            method: 'get',
            responseType: 'blob'
        }).then((response) => {
            this.setState({locationPrinting: null});
            if (response.status === 200) {
                fileDownload(response.data, 'location_' + locationName.replace(/[^0-9a-zA-z]+/g, "-") + '.pdf', 'application/pdf');
            }
        });
    }

    render() {
        const { t } = this.props;
        return (
            <div className="LocationGroupsScreen">
                <PageHeader title={t('locations.title')} loading={this.state.loading}/>
                <div className="row m-t m-b">
                    <div className="col-md-4">
                        <input type="text" name="filterName" value={this.state.filterName} onChange={this.handleInputChange} className="form-control" placeholder={t('locations.filterName.placeholder')}/>
                    </div>
                    <div className="col-md-4">
                        <div className="checkbox checkbox-default">
                            <input type="checkbox" name="filterOnlyWithShifts" id="locations-filterOnlyWithShifts-checkbox" checked={this.state.filterOnlyWithShifts}
                                   onChange={this.handleCheckboxChange}/>
                            <label htmlFor="locations-filterOnlyWithShifts-checkbox">{t('locations.filterOnlyWithShifts.label')}</label>
                        </div>
                    </div>
                </div>
                {this.state.locationGroups.filter((el) => {return !this.state.filterOnlyWithShifts ||el.locations.find((el2) => {return el2.shiftAmount > 0})}).filter((el) => {return el.name.toLowerCase().indexOf(this.state.filterName.toLowerCase()) !== -1 || el.locations.find((el2) => { return el2.name.toLowerCase().indexOf(this.state.filterName.toLowerCase()) !== -1})}).map((locationGroup, i) => (
                    <div className="ibox" key={i}>
                        <div className="ibox-title">
                            <h5>
                                {locationGroup.name}
                                <small className="text-muted">
                                    &nbsp;{locationGroup.comment}
                                </small>
                            </h5>
                            <div className="ibox-tools">
                                <EditLocationGroup id={locationGroup.id} handleClose={this.loadLocationGroups}/>
                            </div>
                        </div>
                        <div className="ibox-content">
                            <table className="table no-border-top-first-row">
                                <tbody>
                                    {locationGroup.locations ? locationGroup.locations.filter((el) => {return !this.state.filterOnlyWithShifts || el.shiftAmount > 0}).map((location, j) => (
                                        <tr key={i+j}>
                                            <td>
                                                <div className="location" key={i+j}>
                                                    <div>
                                                        <div className="pull-right">
                                                            {location.shiftAmount} {t('default.shifts')} | {t('default.workType.name')} {t('default.workType.' + location.workType)} |
                                                            <EditLocation id={location.id} handleClose={this.loadLocationGroups}/> |
                                                            &nbsp;<a onClick={() => this.state.locationPrinting !== location.id ? this.handlePrintLocationSheet(location.id, location.name) : null}>
                                                                <i className={`fa ${this.state.locationPrinting !== location.id ? 'fa-file-pdf-o' : 'fa-spinner fa-spin'}`}/>
                                                            </a>
                                                        </div>
                                                        <h4>
                                                            {location.name}
                                                            <small className="text-muted">
                                                                &nbsp;{location.description}
                                                            </small>
                                                        </h4>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )) : null}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        )
    }
}
export default translate()(LocationGroupsScreen);
